import React, { useState } from "react";
import ModalComponent from "../../../ModalComponent";
import DraggableDialog from "../../../DraggableDialog";
import classes from "./index.module.scss";

function Index({ handleOpenCloseVisit, handleCloseCloseVisit }) {
  const [showConfirmFinalVisit, setShowConfirmFinalVisit] = useState(false);
  const [showConfirmCancelVisit, setShowConfirmCancelVisit] = useState(false);

  const handleFinalVisit = () => {
    setShowConfirmFinalVisit(true);
  };

  const handleCancelVisit = () => {
    setShowConfirmCancelVisit(true);
  };
  return (
    <ModalComponent
      open={handleOpenCloseVisit}
      handleClose={handleCloseCloseVisit}
      closeBtn={true}
      // confirmBtn={false}
      // handleOk={null}
      title="CloseVisit Modal"
    >
      <div>
        <ul>
          <li className={classes.listItem} onClick={handleFinalVisit}>
            <p>
              You terminate the visit and your visit fee is credited to your
              account
            </p>
          </li>
          <li className={classes.listItem} onClick={handleCancelVisit}>
            <p>
              Return the visit fee to the patient account with the deduction of
              the server subscription fee
            </p>
          </li>
        </ul>
        <DraggableDialog
          open={showConfirmFinalVisit}
          handleClose={() => setShowConfirmFinalVisit(false)}
          title="final visit"
          ContentText="The visit is terminated and the visit fee will be credited to your account. Are you sure?"
          handleOk={() => alert("asd")}
        />

        <DraggableDialog
          open={showConfirmCancelVisit}
          handleClose={() => setShowConfirmCancelVisit(false)}
          title="refunded to the patient's account by deducting the site tariff"
          ContentText="The patient's payment will be refunded to the patient's account by deducting the site tariff, are you sure?"
          handleOk={() => alert("asd")}
        />
      </div>
    </ModalComponent>
  );
}

export default Index;
